import {
    _axios as request
} from "../../plugins/axios";
import GLOBAL from "@/utils/global.js";

const actions = {
    // 获取导出任务列表
    getExportTaskList(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/getall',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
    // 获取库存信息统计表
    getStockTable(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/stockTable',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
    // 获取商品销量数据统计表
    getSpuSalesRankTable(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/spuSalesRankTable',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
    // 获取销售统计表
    getSalesTable(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/salesTable',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
    // 获取订单明细表
    getOrderListTable(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/orderListTable',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
    // 下载文件
    downloadFile(_, fileName) {
        return new Promise((resolve, reject) => {
            request({
                url: `/table/${fileName}`,
                method: 'get',
                responseType: 'blob',
                baseURL: GLOBAL.baseURL,
                headers: {
                    'Accept': 'application/octet-stream'
                }
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

const mutations = {};

const state = {};

const getters = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 